import Vue from 'vue';
import axios from 'axios';
import vSelect from 'vue-select';

Vue.component('v-select', vSelect);

export default (form) => {
    if (form.querySelector('.vue-linked-dropdowns')) {
        Array.from(form.querySelectorAll('.vue-linked-dropdowns')).forEach((element) => {
            new Vue({
                el: element,
                delimiters: ['${', '}'],
                components: {
                    vSelect,
                },
                data: {
                    itemsPrimary: [],
                    itemsPrimaryApi: null,
                    itemsPrimarySelectedId: null,
                    itemsSecondary: [],
                    itemsSecondaryApi: null,
                    itemsSecondaryValue: null,
                    itemsSecondaryValueKey: null,
                    isLoading: true,
                },
                computed: {
                    itemsSecondaryApiFiltered() {
                        return `${this.itemsSecondaryApi}?relatedTo=${this.itemsPrimarySelectedId}`;
                    },
                },
                watch: {
                    itemsPrimarySelectedId() {
                        this.fetch(this.itemsSecondaryApiFiltered)
                            .then((items) => {
                                this.itemsSecondary = items;
                            });
                    },
                },
                beforeMount() {
                    this.itemsPrimaryApi = this.$el.attributes['data-primary-api'].value;
                    this.itemsSecondaryApi = this.$el.attributes['data-secondary-api'].value;
                    this.itemsSecondaryValueKey = this.$el.attributes['data-secondary-value-key'].value;
                    this.fetch(this.itemsPrimaryApi).then((items) => {
                        this.itemsPrimary = items;
                    });
                },
                methods: {
                    fetch(api) {
                        this.isLoading = true;
                        return axios.get(api)
                            .then((results) => {
                                this.isLoading = false;
                                return results.data.data;
                            });
                    },
                    setItemsPrimarySelectedId(value) {
                        this.itemsPrimarySelectedId = (value ? value.id : null);
                    },
                    setItemsSecondaryValue(value) {
                        this.itemsSecondaryValue = (value ? value[this.itemsSecondaryValueKey || 'title'] : null);
                    },
                },
            });
        });
    }
};
